module.exports = __webpack_public_path__ + "static/media/content-review.82deb892.gif";